import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import StudentEditForm from "../../forms/studentEditForm";
import StudentTurnStep from "../../forms/studentTurnStep";
import CustomButton from "../../../../components/lib/customButton";
import Stepper from "../../../../components/lib/stepperHeader";

const STEP = { STUDENT: 0, TURNS: 1 };

const visualSteps = [
    { key: STEP.STUDENT, label: "Aluno" },
    { key: STEP.TURNS, label: "Turma e Turnos" },
];

const Spinner = () => (
    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
);

const StudentEditStepper = ({ student, initialTurnIds = [], onClose, onFinish, onDirty, isSubmitting }) => {
    const [step, setStep] = useState(STEP.STUDENT);
    const [studentDraft, setStudentDraft] = useState(null);

    const submitActiveForm = () => {
        document.querySelector("form[data-step-form]")?.requestSubmit();
    };

    const goBack = () => {
        if (step === STEP.STUDENT) return onClose();
        setStep(step - 1);
    };

    return (
        <div className="flex flex-col gap-4">
            <Stepper steps={visualSteps} currentStep={step} />

            <div className="min-h-[360px]">
                <AnimatePresence mode="wait">
                    <motion.div key={step} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.2 }}>

                        {step === STEP.STUDENT && (
                            <StudentEditForm
                                isOpen={true}
                                student={student}
                                onDirty={onDirty}
                                hideFooter
                                onSubmit={(data) => {
                                    setStudentDraft(data);
                                    setStep(STEP.TURNS);
                                }}
                                onClose={onClose}
                            />
                        )}

                        {step === STEP.TURNS && (
                            <StudentTurnStep
                                initialGrade={student?.grade ?? ""}
                                initialTurnIds={initialTurnIds}
                                onDirty={onDirty}
                                onSubmit={(data) => {
                                    onFinish({
                                        student: { ...studentDraft, grade: data.grade },
                                        turnIds: data.turnIds,
                                    });
                                }}
                            />
                        )}

                    </motion.div>
                </AnimatePresence>
            </div>

            <div className="flex justify-between">
                <CustomButton
                    buttonType={step === STEP.STUDENT ? "cancel" : "confirmLater"}
                    text={step === STEP.STUDENT ? "Cancelar" : "Voltar"}
                    showIcon={false}
                    onClick={goBack}
                />
                <CustomButton
                    buttonType="confirm"
                    text={
                        step === STEP.TURNS && isSubmitting ? (
                            <>
                                <span className="ml-2">Salvando</span>
                                <Spinner />
                            </>
                        ) : step === STEP.TURNS ? "Salvar" : "Avançar"
                    }
                    showIcon={false}
                    disabled={isSubmitting}
                    onClick={submitActiveForm}
                />
            </div>
        </div>
    );
};

export default StudentEditStepper;
